export default __webpack_public_path__ + "static/media/empresas.85e99d82.jpg";